/**
 * Derive the aggregate status of a post group from its individual posts.
 * Mirrors the logic inlined in PostArticle.js so the list view stays consistent.
 *
 * @param {Object} postGroup - post group with a `posts` array
 * @returns {"published"|"publishing"|"error"|"pending"}
 */
export const getPostGroupStatus = (postGroup) => {
    const posts = postGroup?.posts || [];

    const published = posts.filter((p) => p?.status != 'published')?.length == 0;
    const publishing = posts.filter((p) => p?.status == 'publishing')?.length > 0;
    const error = posts.filter((p) => p?.status == 'error' && !!p?.status_message)?.length > 0;

    return published ? 'published' : publishing ? 'publishing' : error ? 'error' : 'pending';
};

/** Tailwind color token used across the app for each status. */
export const POST_GROUP_STATUS_COLORS = {
    published: 'emerald-500',
    publishing: 'cyan-800',
    error: 'red-600',
    pending: 'primary-600',
};

export default getPostGroupStatus;
